var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("selectLocale",function(){return [_c('v-select',{attrs:{"items":_vm.locales,"label":_vm.$vuetify.lang.t('$vuetify.language')},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})]},{"locale":_vm.locale,"changeLocale":_vm.changeLocale,"locales":_vm.locales})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }